import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Link from "../link";
import Resource from "./resource";

@JsonObject()
export class EntityPermissionPolicy {
    @JsonProperty("is_group_policy")
    isGroupPolicy: boolean;

    @JsonProperty("policy")
    policy: Link;

    @JsonProperty("rule_identifiers")
    @JsonElementType(String)
    policyRuleIdentifiers: Array<string> = [];
}

@JsonObject()
export class EntityPermission {
    @JsonProperty("permission")
    permission: string;

    @JsonProperty("policies")
    @JsonElementType(EntityPermissionPolicy)
    policies: Array<EntityPermissionPolicy> = [];
}

@JsonObject()
export class UserEntityPermissionsResource extends Resource {
    @JsonProperty("permissions")
    @JsonElementType(EntityPermission)
    permissions: Array<EntityPermission>;
}
